import { combineReducers } from 'redux'

import detalhesReceitaDiaria from './detalhesReceitaDiaria'

export default combineReducers({ detalhesReceitaDiaria })
